<!--
	@component
	Generates a hover tooltip. It creates a slot with an exposed variable via `let:detail` that contains information about the event. Use the slot to populate the body of the tooltip using the exposed variable `detail`.
 -->
<script>
	/** @type {Object} evt �A svelte event created via [`dispatch`](https://svelte.dev/docs#createEventDispatcher) with event information under `evt.detail.e`. */
  export let evt = {};

	/** @type {Number} [offset=-35] �A y-offset from the hover point, in pixels. */
  export let offset = 0;
</script>

<style>
  .tooltip {
    position: absolute;
		font-size: 13px;
		pointer-events: none;
		border: 1px solid #d3d3d3;
    /* box-shadow: 5px 5px 20px rgb(211, 211, 211, 0.5); */
		background: rgba(255, 255, 255, 1);
		transform: translate(-50%, -100%);
    padding: 5px;
    z-index: 100;
    pointer-events: none;
    font-family: 'Open Sans', sans-serif;
    width: 125px;
  }
</style>

{#if evt.detail}
  <div
    class="tooltip"
    style="
      top:{evt.detail.e.layerY + offset}px;
      left:{evt.detail.e.layerX + 60}px;
    "
  >
    <slot detail={evt.detail}></slot>
  </div>
{/if}
